import { render, staticRenderFns } from "./photoFigureList.vue?vue&type=template&id=7900a966"
import script from "./photoFigureList.vue?vue&type=script&lang=js"
export * from "./photoFigureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports